import { type Registry as Services, service } from '@ember/service';
import type { Snapshot } from '@ember-data/legacy-compat/-private';
import ApplicationAdapter from 'lumen/adapters/application';

export default class CurrencyConversionOrganizationContextAdapter extends ApplicationAdapter {
  @service('hotel-and-market')
  declare hotelAndMarketService: Services['hotel-and-market'];

  // @ts-expect-error: Property 'buildURL' in type is not assignable to the same property in base type.
  buildURL(
    modelName: string,
    id: string,
    snapshot: Snapshot<unknown>,
    requestType: string,
    query?: Record<string, unknown>,
  ): string {
    // @ts-expect-error: Expected 3 arguments, but got 5.
    const baseUrl = super.buildURL(modelName, id, snapshot, requestType, query);

    const url = new URL(baseUrl, this.host);
    const { hotel, market } = this.hotelAndMarketService;
    if (hotel) {
      url.searchParams.set('subscription_id', hotel.id!);
    }
    if (market) {
      url.searchParams.set('market_id', market.id!);
    }

    return url.toString();
  }

  // Prevent 'organization-context' → 'organization-contexts' pluralisation in handleQuery
  pathForType(): string {
    return 'bi/organization-context';
  }

  urlForUpdateRecord(): string {
    return '/apigateway/v1/app/bi/organization-context';
  }
}
